async function updateStatsData() {
  const url = " https://dashboard.lonedesignclub.com/public/popup/count";
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const statsData = await response.json();
    if (statsData) {
      const clubhouseStats = document.getElementById('clubhouse-stats');
      if (!clubhouseStats) {
        return;
      }
      const live = clubhouseStats.getElementsByClassName('stat-1')[0];
      const total_brand = clubhouseStats.getElementsByClassName('stat-2')[0];
      const event_count = clubhouseStats.getElementsByClassName('stat-3')[0];
      const total_event = clubhouseStats.getElementsByClassName('stat-4')[0];
      if (live && live.innerHTML.replace(/\s/g, "") === '-') {
        live.innerHTML = statsData.live_activation_count;
      }
      if (total_brand && total_brand.innerHTML.replace(/\s/g, "") === '-') {
        total_brand.innerHTML = statsData.brand_count;
      }
      if (event_count && event_count.innerHTML.replace(/\s/g, "") === '-') {
        event_count.innerHTML = statsData.event_count;
      }
      if (total_event && total_event.innerHTML.replace(/\s/g, "") === '-') {
        total_event.innerHTML = statsData.total_activation_count;
      }
    }
  } catch (error) {
    console.error(error.message);
  }
}
updateStatsData();
